var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2381"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2381"] = parcelRequire;
}

var $5Fmyj = parcelRequire("5Fmyj");

var $h9NR5 = parcelRequire("h9NR5");

var $7eXHk = parcelRequire("7eXHk");

var $10VxQ = parcelRequire("10VxQ");
/*!
 * DrawSVGPlugin 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $1ad04a3649455f90$var$gsap, $1ad04a3649455f90$var$_toArray, $1ad04a3649455f90$var$_doc, $1ad04a3649455f90$var$_win, $1ad04a3649455f90$var$_isEdge, $1ad04a3649455f90$var$_coreInitted, $1ad04a3649455f90$var$_warned, $1ad04a3649455f90$var$_getStyleSaver, $1ad04a3649455f90$var$_reverting, $1ad04a3649455f90$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $1ad04a3649455f90$var$_getGSAP = function _getGSAP() {
    return $1ad04a3649455f90$var$gsap || $1ad04a3649455f90$var$_windowExists() && ($1ad04a3649455f90$var$gsap = window.gsap) && $1ad04a3649455f90$var$gsap.registerPlugin && $1ad04a3649455f90$var$gsap;
}, $1ad04a3649455f90$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$1ad04a3649455f90$var$_types = {
    rect: [
        "width",
        "height"
    ],
    circle: [
        "r",
        "r"
    ],
    ellipse: [
        "rx",
        "ry"
    ],
    line: [
        "x2",
        "y2"
    ]
}, $1ad04a3649455f90$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $1ad04a3649455f90$var$_parseNum = function _parseNum(value) {
    return parseFloat(value) || 0;
}, $1ad04a3649455f90$var$_parseSingleVal = function _parseSingleVal(value, length) {
    var num = $1ad04a3649455f90$var$_parseNum(value);
    return ~value.indexOf("%") ? num / 100 * length : num;
}, $1ad04a3649455f90$var$_getAttributeAsNumber = function _getAttributeAsNumber(target, attr) {
    return $1ad04a3649455f90$var$_parseNum(target.getAttribute(attr));
}, $1ad04a3649455f90$var$_sqrt = Math.sqrt, $1ad04a3649455f90$var$_getDistance = function _getDistance(x1, y1, x2, y2, scaleX, scaleY) {
    return $1ad04a3649455f90$var$_sqrt(Math.pow(($1ad04a3649455f90$var$_parseNum(x2) - $1ad04a3649455f90$var$_parseNum(x1)) * scaleX, 2) + Math.pow(($1ad04a3649455f90$var$_parseNum(y2) - $1ad04a3649455f90$var$_parseNum(y1)) * scaleY, 2));
}, $1ad04a3649455f90$var$_warn = function _warn(message) {
    return console.warn(message);
}, $1ad04a3649455f90$var$_hasNonScalingStroke = function _hasNonScalingStroke(target) {
    return target.getAttribute("vector-effect") === "non-scaling-stroke";
}, $1ad04a3649455f90$var$_bonusValidated = 1, //<name>DrawSVGPlugin</name>
//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
$1ad04a3649455f90$var$_parse = function _parse(value, length, defaultStart) {
    var i = value.indexOf(" "), s, e;
    if (i < 0) {
        s = defaultStart !== undefined ? defaultStart + "" : value;
        e = value;
    } else {
        s = value.substr(0, i);
        e = value.substr(i + 1);
    }
    s = $1ad04a3649455f90$var$_parseSingleVal(s, length);
    e = $1ad04a3649455f90$var$_parseSingleVal(e, length);
    return s > e ? [
        e,
        s
    ] : [
        s,
        e
    ];
}, $1ad04a3649455f90$var$_getLength = function _getLength(target) {
    target = $1ad04a3649455f90$var$_toArray(target)[0];
    if (!target) return 0;
    var type = target.tagName.toLowerCase(), style = target.style, scaleX = 1, scaleY = 1, length, bbox, points, prevPoint, i, rx, ry;
    if ($1ad04a3649455f90$var$_hasNonScalingStroke(target)) {
        //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
        scaleY = target.getScreenCTM();
        scaleX = $1ad04a3649455f90$var$_sqrt(scaleY.a * scaleY.a + scaleY.b * scaleY.b);
        scaleY = $1ad04a3649455f90$var$_sqrt(scaleY.d * scaleY.d + scaleY.c * scaleY.c);
    }
    try {
        //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
        bbox = target.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
    } catch (e) {
        //firefox has a bug that throws an error if the element isn't visible.
        $1ad04a3649455f90$var$_warn("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }
    var _ref = bbox || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    if ((!bbox || !width && !height) && $1ad04a3649455f90$var$_types[type]) {
        //if the element isn't visible, try to discern width/height using its attributes.
        width = $1ad04a3649455f90$var$_getAttributeAsNumber(target, $1ad04a3649455f90$var$_types[type][0]);
        height = $1ad04a3649455f90$var$_getAttributeAsNumber(target, $1ad04a3649455f90$var$_types[type][1]);
        if (type !== "rect" && type !== "line") {
            //double the radius for circles and ellipses
            width *= 2;
            height *= 2;
        }
        if (type === "line") {
            x = $1ad04a3649455f90$var$_getAttributeAsNumber(target, "x1");
            y = $1ad04a3649455f90$var$_getAttributeAsNumber(target, "y1");
            width = Math.abs(width - x);
            height = Math.abs(height - y);
        }
    }
    if (type === "path") {
        prevPoint = style.strokeDasharray;
        style.strokeDasharray = "none";
        length = target.getTotalLength() || 0;
        $1ad04a3649455f90$var$_round(scaleX) !== $1ad04a3649455f90$var$_round(scaleY) && !$1ad04a3649455f90$var$_warned && ($1ad04a3649455f90$var$_warned = 1) && $1ad04a3649455f90$var$_warn("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
        length *= (scaleX + scaleY) / 2;
        style.strokeDasharray = prevPoint;
    } else if (type === "rect") length = width * 2 * scaleX + height * 2 * scaleY;
    else if (type === "line") length = $1ad04a3649455f90$var$_getDistance(x, y, x + width, y + height, scaleX, scaleY);
    else if (type === "polyline" || type === "polygon") {
        points = target.getAttribute("points").match($1ad04a3649455f90$var$_numExp) || [];
        type === "polygon" && points.push(points[0], points[1]);
        length = 0;
        for(i = 2; i < points.length; i += 2)length += $1ad04a3649455f90$var$_getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
    } else if (type === "circle" || type === "ellipse") {
        rx = width / 2 * scaleX;
        ry = height / 2 * scaleY;
        length = Math.PI * (3 * (rx + ry) - $1ad04a3649455f90$var$_sqrt((3 * rx + ry) * (rx + 3 * ry)));
    }
    return length || 0;
}, $1ad04a3649455f90$var$_getPosition = function _getPosition(target, length) {
    target = $1ad04a3649455f90$var$_toArray(target)[0];
    if (!target) return [
        0,
        0
    ];
    length || (length = $1ad04a3649455f90$var$_getLength(target) + 1);
    var cs = $1ad04a3649455f90$var$_win.getComputedStyle(target), dash = cs.strokeDasharray || "", offset = $1ad04a3649455f90$var$_parseNum(cs.strokeDashoffset), i = dash.indexOf(",");
    i < 0 && (i = dash.indexOf(" "));
    dash = i < 0 ? length : $1ad04a3649455f90$var$_parseNum(dash.substr(0, i));
    dash > length && (dash = length);
    return [
        -offset || 0,
        dash - offset || 0
    ];
}, $1ad04a3649455f90$var$_initCore = function _initCore() {
    if ($1ad04a3649455f90$var$_windowExists()) {
        $1ad04a3649455f90$var$_doc = document;
        $1ad04a3649455f90$var$_win = window;
        $1ad04a3649455f90$var$_coreInitted = $1ad04a3649455f90$var$gsap = $1ad04a3649455f90$var$_getGSAP();
        $1ad04a3649455f90$var$_toArray = $1ad04a3649455f90$var$gsap.utils.toArray;
        $1ad04a3649455f90$var$_getStyleSaver = $1ad04a3649455f90$var$gsap.core.getStyleSaver;
        $1ad04a3649455f90$var$_reverting = $1ad04a3649455f90$var$gsap.core.reverting || function() {};
        $1ad04a3649455f90$var$_isEdge = (($1ad04a3649455f90$var$_win.navigator || {}).userAgent || "").indexOf("Edge") !== -1; //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
    }
};
var $1ad04a3649455f90$export$4129f9ba90e1264a = {
    version: "3.12.2",
    name: "drawSVG",
    register: function register(core) {
        $1ad04a3649455f90$var$gsap = core;
        $1ad04a3649455f90$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        if (!target.getBBox) return false;
        $1ad04a3649455f90$var$_coreInitted || $1ad04a3649455f90$var$_initCore();
        var length = $1ad04a3649455f90$var$_getLength(target), start, end, cs;
        this.styles = $1ad04a3649455f90$var$_getStyleSaver && $1ad04a3649455f90$var$_getStyleSaver(target, "strokeDashoffset,strokeDasharray,strokeMiterlimit");
        this.tween = tween;
        this._style = target.style;
        this._target = target;
        if (value + "" === "true") value = "0 100%";
        else if (!value) value = "0 0";
        else if ((value + "").indexOf(" ") === -1) value = "0 " + value;
        start = $1ad04a3649455f90$var$_getPosition(target, length);
        end = $1ad04a3649455f90$var$_parse(value, length, start[0]);
        this._length = $1ad04a3649455f90$var$_round(length);
        this._dash = $1ad04a3649455f90$var$_round(start[1] - start[0]); //some browsers render artifacts if dash is 0, so we use a very small number in that case.
        this._offset = $1ad04a3649455f90$var$_round(-start[0]);
        this._dashPT = this.add(this, "_dash", this._dash, $1ad04a3649455f90$var$_round(end[1] - end[0]), 0, 0, 0, 0, 0, 1);
        this._offsetPT = this.add(this, "_offset", this._offset, $1ad04a3649455f90$var$_round(-end[0]), 0, 0, 0, 0, 0, 1);
        if ($1ad04a3649455f90$var$_isEdge) {
            //to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
            cs = $1ad04a3649455f90$var$_win.getComputedStyle(target);
            if (cs.strokeLinecap !== cs.strokeLinejoin) {
                end = $1ad04a3649455f90$var$_parseNum(cs.strokeMiterlimit);
                this.add(target.style, "strokeMiterlimit", end, end + 0.01);
            }
        }
        this._live = $1ad04a3649455f90$var$_hasNonScalingStroke(target) || ~(value + "").indexOf("live");
        this._nowrap = ~(value + "").indexOf("nowrap");
        this._props.push("drawSVG");
        return $1ad04a3649455f90$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$1ad04a3649455f90$var$_reverting()) {
            var pt = data._pt, style = data._style, length, lengthRatio, dash, offset;
            if (pt) {
                //when the element has vector-effect="non-scaling-stroke" and the SVG is resized (like on a window resize), it actually changes the length of the stroke! So we must sense that and make the proper adjustments.
                if (data._live) {
                    length = $1ad04a3649455f90$var$_getLength(data._target);
                    if (length !== data._length) {
                        lengthRatio = length / data._length;
                        data._length = length;
                        if (data._offsetPT) {
                            data._offsetPT.s *= lengthRatio;
                            data._offsetPT.c *= lengthRatio;
                        }
                        if (data._dashPT) {
                            data._dashPT.s *= lengthRatio;
                            data._dashPT.c *= lengthRatio;
                        } else data._dash *= lengthRatio;
                    }
                }
                while(pt){
                    pt.r(ratio, pt.d);
                    pt = pt._next;
                }
                dash = data._dash || ratio && ratio !== 1 && 0.0001 || 0; // only let it be zero if it's at the start or end of the tween.
                length = data._length - dash + 0.1;
                offset = data._offset;
                dash && offset && dash + Math.abs(offset % data._length) > data._length - 0.2 && (offset += offset < 0 ? 0.1 : -0.1) && (length += 0.1);
                style.strokeDashoffset = dash ? offset : offset + 0.001;
                style.strokeDasharray = length < 0.2 ? "none" : dash ? dash + "px," + (data._nowrap ? 999999 : length) + "px" : "0px, 999999px";
            }
        } else data.styles.revert();
    },
    getLength: $1ad04a3649455f90$var$_getLength,
    getPosition: $1ad04a3649455f90$var$_getPosition
};
$1ad04a3649455f90$var$_getGSAP() && $1ad04a3649455f90$var$gsap.registerPlugin($1ad04a3649455f90$export$4129f9ba90e1264a);


if (null) null.accept();
(0, $h9NR5.gsap).registerPlugin((0, $7eXHk.ScrollTrigger), (0, $10VxQ.ScrollSmoother), (0, $1ad04a3649455f90$export$4129f9ba90e1264a));
let $91150532f340a2d1$var$mm = (0, $h9NR5.gsap).matchMedia();
function $91150532f340a2d1$var$init() {
    // initCursor();
    (0, $5Fmyj.initNav)();
}
window.addEventListener("load", function() {
    $91150532f340a2d1$var$init();
});
$91150532f340a2d1$var$mm.add("(min-width: 768px)", ()=>{
    (0, $10VxQ.ScrollSmoother).create({
        smooth: 1,
        effects: true,
        smoothTouch: 0.1,
        normalizeScroll: true
    });
    // Draw Hero Image
    (0, $h9NR5.gsap).from(".mk-hero__image path", {
        duration: 8,
        drawSVG: "0%",
        ease: "slow(0.7, 0.7, false)",
        fill: "transparent"
    });
    (0, $h9NR5.gsap).to(".mk-hero__image", {
        opacity: 1
    });
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".year-num-1854",
        start: "top 20%",
        end: "bottom 40%",
        pin: true,
        pinSpacing: false,
        scrub: true
    });
    // 1856 Scroll Trigger
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".year-num-1856",
        start: "top 20%",
        end: "bottom 40%",
        pin: true,
        pinSpacing: false,
        scrub: true
    });
    // 1867 Scroll Trigger
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".year-num-1867",
        start: "top 20%",
        end: "bottom 40%",
        pin: true,
        pinSpacing: false,
        scrub: true
    });
    // 1871 Scroll Trigger
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".year-num-1871",
        start: "top 20%",
        end: "bottom 40%",
        pin: true,
        pinSpacing: false,
        scrub: true
    });
    // POPULAR HEALING SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $7eXHk.ScrollTrigger).create({
        trigger: "#scrolling-header--big",
        animation: scrolling_headers_animation,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // DISEASE & WAR SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation_disease_war = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-disease-war--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-disease-war--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $7eXHk.ScrollTrigger).create({
        trigger: "#scrolling-header-disease-war--big",
        animation: scrolling_headers_animation_disease_war,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // BERIBERI SCROLLING HEADERS ANIMATION
    const scrolling_headers_animation_beriberi = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).to("#scrolling-header-beriberi--big", {
        xPercent: -400,
        ease: "none"
    }).to("#scrolling-header-beriberi--small", {
        xPercent: 400,
        ease: "none"
    }, "<");
    (0, $7eXHk.ScrollTrigger).create({
        trigger: "#scrolling-header-beriberi--big",
        animation: scrolling_headers_animation_beriberi,
        start: "top 80%",
        end: "bottom -=500",
        scrub: 1
    });
    // KARL FRIEDRICH QUOTE ANIMATION
    const timeline_quote = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).fromTo(".timeline__quote--karl-fridrich", {
        scale: 0
    }, {
        scale: 1
    });
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".section--timeline__quote--karl-friedrich",
        animation: timeline_quote,
        start: "top 60px",
        end: "bottom 600px",
        pin: true,
        // pinSpacing: false,
        scrub: 1,
        anticipatePin: 1
    });
    // PAI MANOEL QUOTE ANIMATION
    const timeline_quote_pai_manoel = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).fromTo(".timeline__quote--pai-manoel", {
        scale: 0
    }, {
        scale: 1
    });
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".section--timeline__quote--pai-manoel",
        animation: timeline_quote_pai_manoel,
        start: "top 60px",
        end: "bottom 600px",
        pin: true,
        // pinSpacing: false,
        scrub: 1,
        anticipatePin: 1
    });
    // DISEASES & WAR QUOTE
    const timeline_quote_diseases_war = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).fromTo(".timeline__quote--diseases-war", {
        scale: 0
    }, {
        scale: 1
    });
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".section--timeline__quote--diseases-war",
        animation: timeline_quote_diseases_war,
        start: "top 60px",
        end: "bottom 600px",
        pin: true,
        // pinSpacing: false,
        scrub: 1,
        anticipatePin: 1
    });
    // BERIBERI QUOTE
    const timeline_quote_beriberi = (0, $h9NR5.gsap).timeline({
        paused: "true"
    }).fromTo(".timeline__quote--beriberi", {
        scale: 0
    }, {
        scale: 1
    });
    (0, $7eXHk.ScrollTrigger).create({
        trigger: ".section--timeline__quote--beriberi",
        animation: timeline_quote_beriberi,
        start: "top 60px",
        end: "bottom 600px",
        pin: true,
        // pinSpacing: false,
        scrub: 1,
        anticipatePin: 1
    });
});
// mm.add("(min-width: 768px)", () => {
//   ScrollTrigger.create({
//     trigger: ".section--theme-lead-in",
//     animation: theme_lead_in_animation_tl,
//     start: "top 20%",
//   });
// });
// Draw Theme Lead In
const $91150532f340a2d1$var$theme_lead_in_animation_tl = (0, $h9NR5.gsap).timeline({
    paused: "true"
});
$91150532f340a2d1$var$theme_lead_in_animation_tl.from(".theme-lead-in__image path", {
    duration: 4,
    drawSVG: "0%",
    ease: "slow(0.7, 0.7, false)"
});
$91150532f340a2d1$var$theme_lead_in_animation_tl.to(".theme-lead-in__wrapper", {
    opacity: 1
}, 0);
$91150532f340a2d1$var$theme_lead_in_animation_tl.to(".theme-lead-in__image .cls-1", {
    fill: "#191919",
    duration: 2
});
$91150532f340a2d1$var$theme_lead_in_animation_tl.to(".theme-lead-in__arrow-right", {
    width: "100%",
    duration: 0.5
}, "<.5");
$91150532f340a2d1$var$theme_lead_in_animation_tl.to(".theme-lead-in__next", {
    opacity: 1,
    duration: 1
}, "<+.5");
(0, $7eXHk.ScrollTrigger).create({
    trigger: ".section--theme-lead-in",
    animation: $91150532f340a2d1$var$theme_lead_in_animation_tl,
    start: "top 20%"
});


//# sourceMappingURL=medical-knowledge.65e21849.js.map
